module.exports = __webpack_public_path__ + "img/icon-mx-server.529b5e1c.svg";